import React, { useEffect, useState } from 'react';
import { FaSpinner, FaSearch, FaExchangeAlt } from "react-icons/fa";
import { useParams, useNavigate } from 'react-router-dom';
import { Switch } from "@material-tailwind/react";

import { useSettings } from '../context/SettingsContext'
import { Nav } from './partials/Nav';
import { API_URL } from './Constants';
import Loading from './partials/Loading';

const Add = () => {
  const { transactionId, userId } = useParams();
  const settings = useSettings();
  const token = settings.userToken;
  const navigate = useNavigate();

  // UI states
  const [loadingTransaction, setLoadingTransaction] = useState(false)
  const [isSaving, setIsSaving] = useState(false)
  const [paymentRequired, setPaymentRequired] = useState(false)
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState(''); // 'success' or 'error'

  // Form data state
  const [formData, setFormData] = useState({
    hangTag: '',
    customerName: '',
    customerPhone: '',
    customerEmail: '',
    vehicleMake: '',
    vehiclePlate: '',
    vehicleColor: '',
    lot: null,
    status: -1,
    driver: settings.userName ? settings.userName : '',
    stallNumber: '',
    parkerHangtag: '',
    paymentMethod: 0,
    companyName: ''
  })

  // Update form data helper function
  const updateFormData = (updates) => {
    setFormData(prev => ({
      ...prev,
      ...updates
    }))
  }
  
  // Get the user's name from the settings context
  useEffect(() => {
    if (settings && settings.userName) {
      updateFormData({ driver: settings.userName })
    }
  }, [settings]);

  useEffect(() => {
    //console.log('data ' + userId);

    if (!settings.selectedLot) {
      navigate('/');
      return;
    }

    var myHeaders = new Headers();
    myHeaders.append("vp-session-token", token);

    var formdata = new FormData();
    formdata.append("id", settings.selectedLot);

    if (userId) {
      formdata.append("userId", userId);
    }

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(API_URL + "getlots", requestOptions)
      .then(response => response.json())
      .then(result => {
        if (result.code == 200) {
          let temp = result.user.key_tag;
          if (result.user.hangtag) {
            temp = result.user.hangtag;
          } 

          updateFormData({
            lot: result.lot,
            ...(result.user && {
              hangTag: temp || '',
              parkerHangtag: result.user.hangtag || '',
              vehiclePlate: result.user.tag || '',
              companyName: result.user.customer_name || result.user.name || '',
              customerPhone: result.user.customer_phone || '',
              customerEmail: result.user.customer_email || '',
              vehicleMake: result.user.vehicle_make || '',
              vehicleColor: result.user.vehicle_color || '',
              paymentMethod: '2'
            })
          });
        }
      })
      .catch(error => console.log('error', error));
    
    // transaction edit
    if (transactionId && transactionId !== 0) {
      console.log('getting transaction');
      setLoadingTransaction(true)

      var myHeaders = new Headers();
      myHeaders.append("vp-session-token", token);

      var formdata = new FormData();
      formdata.append("id", transactionId);

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(API_URL + "gettransaction", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.code == 200) {
            let temp = result.parker_key_tag;
            if (result.parker_hangtag) {
              temp = result.parker_hangtag;
            } 

            updateFormData({
              lot: result.lot,
              hangTag: result.transaction.key_tag || '',
              companyName: result.transaction.company_name || '',
              customerName: result.transaction.customer_name || '',
              customerEmail: result.transaction.customer_email || '',
              customerPhone: result.transaction.customer_phone || '',
              vehicleColor: result.transaction.vehicle_color || '',
              vehicleMake: result.transaction.vehicle_make || '',
              vehiclePlate: result.transaction.vehicle_plate || '',
              status: result.transaction.status || -1,
              parkerHangtag: temp || '',
              paymentMethod: result.payment_method || '',
              stallNumber: result.stall_number || '',
            });
          } else {
            alert(result.message);
          }

          setLoadingTransaction(false)
        })
        .catch(error => console.log('error', error));
    }
  }, [settings.selectedLot])

  const handleSave = () => {
    setIsSaving(true)

    if (!formData.hangTag) {
      setIsSaving(false)
      alert('Hang tag number is required. Please try again.');
      return;
    }

    if (!formData.customerPhone) {
      setIsSaving(false)
      alert('Customer phone number is required. Please provide a phone number that can receive text messages and try again.');
      return;
    }

    //save data
    var myHeaders = new Headers();
    myHeaders.append("vp-session-token", token);

    var formdata = new FormData();
    formdata.append("key_tag", formData.hangTag);
    formdata.append("lot", formData.lot.id);
    formdata.append("charge_amount", formData.lot.charge_amount);
    formdata.append("fee_collected", formData.lot.fee);
    formdata.append("driver", formData.driver);
    formdata.append("stall_number", formData.stallNumber);
  
    if (transactionId) {
      formdata.append("transaction_id", transactionId);
      if (formData.status) {
        formdata.append("status", formData.status);
      }
    }

    if (formData.companyName) {
      formdata.append("company_name", formData.companyName);
    }
    if (formData.customerEmail) {
      formdata.append("customer_email", formData.customerEmail);
    }
    if (formData.customerPhone) {
      formdata.append("customer_phone", formData.customerPhone);
    }
    if (formData.vehicleColor) {
      formdata.append("vehicle_color", formData.vehicleColor);
    }
    if (formData.vehiclePlate) {
      formdata.append("vehicle_plate", formData.vehiclePlate);
    }
    if (formData.vehicleMake) {
      formdata.append("vehicle_make", formData.vehicleMake);
    }
    if (formData.customerName) {
      formdata.append("customer_name", formData.customerName);
    }

    formdata.set('payment_method', formData.paymentMethod)
    if (formData.paymentMethod == 1 || formData.paymentMethod == 3) {
      formdata.set("fee_collected", formData.lot.fee);
      //formdata.set("status", 2);
    }
    if (formData.parkerHangtag) {
      formdata.append("parker_hangtag", formData.parkerHangtag);
      formdata.set("fee_collected", 0.0);
      //formdata.set("status", 2);
    }
    
    formdata.set("event", 'add'); 
    
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(API_URL + "addparking", requestOptions)
      .then(response => response.json())
      .then(result => {
        if (result.code == 200) {
          navigate('/');
        } else {
          alert(result.message);
        }
        setIsSaving(false)
      })
      .catch(error => {
        alert('There was an unexpected error. '+error+' Please try again.');
      });
  }

  const handleInputChange = (field, value) => {
    updateFormData({ [field]: value });

    // Special handling for hangtag validation
    if (field === 'hangTag') {
      if (value) {
        const numValue = parseInt(value);
        if (numValue >= 3500 && numValue <= 3599) {
          setPaymentRequired(true);
          if (formData.paymentMethod === "3") {
            updateFormData({ paymentMethod: "0" });
          }
        } else {
          setPaymentRequired(false);
        }
      } else {
        setPaymentRequired(false);
      }
    }
  };

  const handlePickerSelect = (event) => {
    handleInputChange('status', event.target.value);
  };

  const handlePlateSearch = () => {
    if (!formData.vehiclePlate) {
      setMessage('Please enter a plate number to search');
      setMessageType('error');
      return;
    }

    var myHeaders = new Headers();
    myHeaders.append("vp-session-token", token);

    var formdata = new FormData();
    formdata.append("term", formData.vehiclePlate);

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(API_URL + "platesearch", requestOptions)
      .then(response => response.json())
      .then(result => {
        if (result.code === 200) {
          const customer = result.customer;
          updateFormData({
            companyName: customer.company || '',
            customerName: customer.name || '',
            customerPhone: customer.phone || '',
            customerEmail: customer.email || '',
            vehicleColor: customer.color || '',
            vehiclePlate: customer.plate || formData.vehiclePlate,
            vehicleMake: customer.make || ''
          });
          setMessage(result.message);
          setMessageType('success');
        } else {
          setMessage(result.message);
          setMessageType('error');
        }
      })
      .catch(error => {
        setMessage('An error occurred while searching. Please try again.');
        setMessageType('error');
        console.log('error', error);
      });
  };

  const handlePickerPayment = (event) => {
    handleInputChange('paymentMethod', event.target.value);
  };

  const handleSwapNames = () => {
    const tempCompanyName = formData.companyName;
    const tempCustomerName = formData.customerName;
    
    updateFormData({
      companyName: tempCustomerName,
      customerName: tempCompanyName
    });
  };

  return (
    <div className='h-full flex bg-primary w-full'>
      <div className='flex-1 bg-white w-full'>
        <Nav back={true}>Add Valet Parking</Nav>
        
        {loadingTransaction ? (
          <Loading />
        ) : (
          <>
            <div className='flex-1 w-full py-12 mx-auto max-w-3xl'>
              <div className='p-5 w-full'>
                {formData.parkerHangtag && (
                  <div className='mx-auto max-w-2xl w-full mb-10'>
                    <p className='text-center font-bold'>Note: Monthly Parker data has been auto filled.</p>
                  </div>
                )}

                <p className='uppercase text-lg lg:text-2xl md:text-base font-bold text-primary mx-7 mb-2 text-center mt-5'>Vehicle Plate</p>
                <div className='border-t border-solid border-primary mb-8 p-2 pt-5 mt-3'>
                  {message && (
                    <div className={`mb-4 p-3 rounded ${messageType === 'success' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                      {message}
                    </div>
                  )}
                  <div className="relative flex items-center">
                    <input
                      id="vehicle_plate"
                      type='text'
                      className='border border-solid border-gray-500 rounded p-2 lg:text-xl text-sm w-full'
                      onChange={(event) => handleInputChange('vehiclePlate', event.target.value)}
                      onBlur={(event) => handleInputChange('vehiclePlate', event.target.value)}
                      editable="true"
                      value={formData.vehiclePlate}
                      autoCorrect="false"
                    />
                    <button 
                      onClick={handlePlateSearch}
                      className="absolute right-2 p-2 text-gray-600 hover:text-primary transition-colors cursor-pointer"
                      type="button"
                      aria-label="Search plate"
                    >
                      <FaSearch className="text-xl" />
                    </button>
                  </div>
                </div>

                <p className='uppercase text-lg lg:text-2xl md:text-base font-bold text-primary mx-7 mb-2 text-center mt-5'>Valet Parking Information</p>
                <div className='w-full p-2 px-5 border-t border-solid border-primary'>
                  <div className=' mb-4 mt-3'>
                    <p className='mr-2 mb-3 lg:text-xl text-base md:text-sm'>Valet Hang Tag Number *</p>
                    <input
                      id="hangtag"
                      type='text'
                      className='border border-solid border-gray-500 rounded p-2 lg:text-xl text-base md:text-sm w-full'
                      onChange={(event) => handleInputChange('hangTag', event.target.value)}
                      onBlur={(event) => handleInputChange('hangTag', event.target.value)}
                      editable="true"
                      value={formData.hangTag}
                      autoCorrect="false"
                    />
                  </div>

                  <div className=' mb-8 mt-3'>
                    <p className='mr-2 mb-3 lg:text-xl text-base'>Valet Driver</p>
                    <input
                      id="driver"
                      type='text'
                      className='border border-solid border-gray-500 rounded p-2 lg:text-xl text-sm w-full'
                      onChange={(event) => handleInputChange('driver', event.target.value)}
                      onBlur={(event) => handleInputChange('driver', event.target.value)}
                      editable="true"
                      value={formData.driver}
                      autoCorrect="false"
                    />
                  </div>

                  <div className=' mb-8 mt-3'>
                    <p className='mr-2 mb-3 lg:text-xl text-base'>Valet Parking Stall Number <span className='text-sm'>(Can be added later)</span></p>
                    <input
                      id="stall_number"
                      type='text'
                      className='border border-solid border-gray-500 rounded p-2 lg:text-xl text-sm w-full'
                      onChange={(event) => handleInputChange('stallNumber', event.target.value)}
                      onBlur={(event) => handleInputChange('stallNumber', event.target.value)}
                      editable="true"
                      value={formData.stallNumber}
                      autoCorrect="false"
                    />
                  </div>

                  {!formData.parkerHangtag ? (
                    <div className=' mb-8 mt-3'>
                      <p className='mr-2 mb-3 lg:text-xl text-base'>Transaction Type</p>
                      {/*<p className='mr-2 mb-3 lg:text-sm text-xs'>If validation code, Customer will be prompted to enter code when they request their car.</p>*/}
                      <select className='w-full border-darkgrey border-solid border rounded p-2' value={formData.paymentMethod} onChange={handlePickerPayment}>
                        <option value="">Select...</option>
                        <option value="-1">Complimentary</option>
                        <option selected value="0">Standard Transaction</option>
                        {/*<option value="1">Cash</option>
                        {!paymentRequired && (
                          <option value="3">No Charge</option>
                        )}*/}
                      </select>
                      {paymentRequired && (
                        <p className='mr-2 mt-3 lg:text-sm text-xs text-red-500 font-bold text-center'>
                          Payment is required for hangtag numbers between 3500-3599. "No Charge" option is not available.
                        </p>
                      )}
                    </div>
                  ) : (
                    <p className='mr-2 mb-3 lg:text-xl text-base'></p>
                  )}
                </div>

                <p className='uppercase text-lg lg:text-2xl md:text-base font-bold text-primary mx-7 mb-2 text-center mt-5'>Customer Information</p>
                <div className='w-full p-2 px-5 border-t border-solid border-primary'>
                  {formData.parkerHangtag && (
                    <div className=' mb-8 mt-3'>
                      <p className='mr-2 mb-3 lg:text-xl text-base'>Monthly Parker Hangtag Number*</p>
                      <input
                        id="parker_hangtag"
                        type='text'
                        className='border border-solid border-gray-500 rounded p-2 lg:text-xl text-sm w-full'
                        onChange={(event) => handleInputChange('parkerHangtag', event.target.value)}
                        onBlur={(event) => handleInputChange('parkerHangtag', event.target.value)}
                        editable="true"
                        value={formData.parkerHangtag}
                        autoCorrect="false"
                      />
                    </div>
                  )}

                  <div className=' mb-4 mt-3'>
                    <p className='mr-2 mb-3 lg:text-xl text-base md:text-sm'>Company Name</p>
                    <input
                      id="name"
                      type='text'
                      className='border border-solid border-gray-500 rounded p-2 lg:text-xl text-base md:text-sm w-full'
                      onChange={(event) => handleInputChange('companyName', event.target.value)}
                      onBlur={(event) => handleInputChange('companyName', event.target.value)}
                      editable="true"
                      value={formData.companyName}
                      autoCorrect="false"
                    />
                  </div>
                  
                  <div className=' mb-4 mt-3'>
                    <p className='mr-2 mb-3 lg:text-xl text-base md:text-sm'>Customer Name</p>
                    <input
                      id="name"
                      type='text'
                      className='border border-solid border-gray-500 rounded p-2 lg:text-xl text-base md:text-sm w-full'
                      onChange={(event) => handleInputChange('customerName', event.target.value)}
                      onBlur={(event) => handleInputChange('customerName', event.target.value)}
                      editable="true"
                      value={formData.customerName}
                      autoCorrect="false"
                    />
                  </div>

                  <div className='flex justify-center items-center mb-10'>
                    <button
                      type="button"
                      onClick={handleSwapNames}
                      className="mt-2 flex items-center justify-center px-3 py-2 text-sm border-primary text-primary border  rounded transition-colors"
                      aria-label="Swap company name and customer name"
                    >
                      <FaExchangeAlt className="mr-2" />
                      Swap Company & Customer Names
                    </button>
                  </div>

                  <div className=' mb-4 mt-3'>
                    <p className='mr-2 mb-1 lg:text-xl text-base'>Customer Phone *</p>
                    <p className='mr-2 mb-3 lg:text-sm text-xs'>Only a mobile number that can receive SMS text messages.</p>
                    <input
                      id="phone"
                      type='text'
                      className='border border-solid border-gray-500 rounded p-2 lg:text-xl text-base md:text-sm w-full'
                      onChange={(event) => handleInputChange('customerPhone', event.target.value)}
                      onBlur={(event) => handleInputChange('customerPhone', event.target.value)}
                      editable="true"
                      value={formData.customerPhone}
                      autoCorrect="false"
                    />
                  </div>

                  <div className=' mb-4 mt-3'>
                    <p className='mr-2 mb-3 lg:text-xl text-base'>Customer Email</p>
                    <input
                      id="email"
                      type='text'
                      className='border border-solid border-gray-500 rounded p-2 lg:text-xl text-sm w-full'
                      onChange={(event) => handleInputChange('customerEmail', event.target.value)}
                      onBlur={(event) => handleInputChange('customerEmail', event.target.value)}
                      editable="true"
                      value={formData.customerEmail}
                      autoCorrect="false"
                    />
                  </div>
                </div>
                  
                <p className='uppercase text-lg lg:text-2xl md:text-base font-bold text-primary mx-7 mb-2 text-center mt-5'>Additional Vehicle Information</p>
                <div className='w-full p-2 px-5 border-t border-solid border-primary'>
                  <div className=' mb-4 mt-3'>
                    <p className='mr-2 mb-3 lg:text-xl text-base'>Vehicle Make</p>
                    <input
                      id="vehicle_make"
                      type='text'
                      className='border border-solid border-gray-500 rounded p-2 lg:text-xl text-sm w-full'
                      onChange={(event) => handleInputChange('vehicleMake', event.target.value)}
                      onBlur={(event) => handleInputChange('vehicleMake', event.target.value)}
                      editable="true"
                      value={formData.vehicleMake}
                      autoCorrect="false"
                    />
                  </div>

                  <div className=' mb-4 mt-3'>
                    <p className='mr-2 mb-3 lg:text-xl text-base'>Vehicle Color</p>
                    <input
                      id="vehicle_color"
                      type='text'
                      className='border border-solid border-gray-500 rounded p-2 lg:text-xl text-sm w-full'
                      onChange={(event) => handleInputChange('vehicleColor', event.target.value)}
                      onBlur={(event) => handleInputChange('vehicleColor', event.target.value)}
                      editable="true"
                      value={formData.vehicleColor}
                      autoCorrect="false"
                    />
                  </div>
                </div>

                {transactionId && (
                  <>
                    <p className='uppercase text-lg lg:text-2xl md:text-base font-bold text-primary mx-7 mb-2 text-center mt-5'>Transaction Status</p>
                    <div className='w-full p-5 border-t border-solid border-primary'>
                      <select className='w-full border-darkgrey border-solid border rounded p-2' value={formData.status} onChange={handlePickerSelect}>
                        <option value="">Select...</option>
                        <option value="1">Open</option>
                        <option value="2">Paid</option>
                        <option value="3">Ready for pickup</option>
                        <option value="4">Close</option>
                      </select>
                    </div>
                  </>
                )}
                
              </div>
            </div>

            <div className='flex bg-primary w-full p-2 py-4'>
              <div className='mx-auto max-w-3xl w-full flex'>
                {isSaving ? (
                  <div className='flex items-center justify-center w-full py-2 px-4 bg-darkgrey rounded-3xl' >
                    <FaSpinner className="text-white fa-spin" />
                  </div>
                ) : (
                  <a className='flex items-center justify-center w-full py-3 px-4 bg-darkgrey rounded-3xl' onClick={handleSave}>
                    <p className='text-center text-white text-xl font-bold uppercase mb-0'>{transactionId ? 'Update' : 'Add'}</p>
                  </a>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default Add;
